function formatNumber (value) {
    if (typeof value !== "undefined") {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return "";
}

export default formatNumber;
